import NETWORKS from "../src/constants/network";
import {ApolloClient, InMemoryCache} from "@apollo/client";

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const NETWORK_APOLLO_CLIENTS = {};


for (let chainId of Object.keys(NETWORKS)) {
    let subGraphs  = NETWORKS[chainId].subgraphs;
    NETWORK_APOLLO_CLIENTS[chainId] = {};
    for(let version of Object.keys(subGraphs)){
        NETWORK_APOLLO_CLIENTS[chainId][version] = new ApolloClient({
            uri: subGraphs[version],
            cache: new InMemoryCache(),
            defaultOptions: defaultOptions,
        });
    }
}

export default NETWORK_APOLLO_CLIENTS;